import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

interface TabMenuProps {
  children: ReactNode;
  isActive: boolean;
  onClick: () => void;
}

const defaultProps = {
  isActive: false,
  onClick() {},
};

function TabMenu({ children, isActive, onClick }: TabMenuProps) {
  return (
    <Box
      aria-selected={isActive}
      as="button"
      borderBottom="3px solid"
      borderBottomColor={isActive ? 'amberYellow900' : 'transparent'}
      borderLeft="1px solid"
      borderLeftColor="transparent"
      borderRight="1px solid"
      borderRightColor="transparent"
      borderTop="1px solid"
      borderTopColor="transparent"
      color={isActive ? 'textNeutralSlightlyLight' : 'textNeutralLight'}
      display="inline-block"
      fontWeight={isActive ? 'bold' : 'regular'}
      pb={'12px'}
      pt={'24px'}
      px={['12px', '18px']}
      role="tab"
      sx={{
        '&:focus-visible': {
          borderBottom: isActive ? '3px solid' : '1px solid',
          borderBottomColor: isActive ? 'amberYellow900' : 'formBorderEmphasisBase',
          borderLeftColor: 'formBorderEmphasisBase',
          borderRightColor: 'formBorderEmphasisBase',
          borderTopColor: 'formBorderEmphasisBase',
        },
        '&:hover': {
          fontWeight: 'bold',
        },
      }}
      tabIndex={0}
      onClick={onClick}
    >
      {children}
    </Box>
  );
}

TabMenu.defaultProps = defaultProps;

export default TabMenu;
